import React from "react";
import { Redirect, Route } from "react-router-dom";

const AdminProtected = ({ component: Cmp, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("admin") ||
      localStorage.getItem("manager") ||
      localStorage.getItem("emp") ? (
        <Cmp {...props} />
      ) : (
        <Redirect to="/logout" />
      )
    }
  />
);

export default AdminProtected;
